import { Pair } from './pair';

export class SiparisOlusturRequest {
  talepId: number;
  teklifKalemIdMiktarList: Pair[] = [];
  siparisNotu: string;
  // teklifId: number;
  // siparisKalemler: SiparisKalem[];
}
